var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 9,
    r: 6.375,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4833 6.87515C10.2219 6.42159 9.73157 6.14921 9.20833 6.16682H7.79167C7.00926 6.16682 6.375 6.80108 6.375 7.58349C6.375 8.36589 7.00926 9.00015 7.79167 9.00015H9.20833C9.99074 9.00015 10.625 9.63442 10.625 10.4168C10.625 11.1992 9.99074 11.8335 9.20833 11.8335H7.79167C7.26843 11.8511 6.77814 11.5787 6.51667 11.1252",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.75C9 4.47386 8.77614 4.25 8.5 4.25C8.22386 4.25 8 4.47386 8 4.75H9ZM8 6.16667C8 6.44281 8.22386 6.66667 8.5 6.66667C8.77614 6.66667 9 6.44281 9 6.16667H8ZM9 11.8333C9 11.5572 8.77614 11.3333 8.5 11.3333C8.22386 11.3333 8 11.5572 8 11.8333H9ZM8 13.25C8 13.5261 8.22386 13.75 8.5 13.75C8.77614 13.75 9 13.5261 9 13.25H8ZM8 4.75V6.16667H9V4.75H8ZM8 11.8333V13.25H9V11.8333H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8c26572f6fe05aab37e937ab9f91072b.svg";
export { ForwardRef as ReactComponent };